import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, inject, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-switch-input',
  templateUrl: './switch-input.component.html',
  styleUrls: ['./switch-input.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SwitchInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SwitchInputComponent implements ControlValueAccessor {
  private cdr = inject(ChangeDetectorRef);

  @Input() controlId: string | null = null;

  public generatedRandomId = `switch-${Math.random().toString(36).slice(2)}`;

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};
  public disabled: boolean = false;

  public isChecked: boolean = false;

  public writeValue(value: boolean): void {
    this.isChecked = value;
    this.cdr.markForCheck();
  }

  public registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  public toggle(): void {
    this.isChecked = !this.isChecked;
    this.onChange(this.isChecked);
    this.onTouched();
  }
}
